import instance from './instance';
import {CheckUrlResponse} from '../types';
import {ProfileType} from '../promotions';

export interface UrlInfoResponse {
  site_id: number;
  type: ProfileType;
  domain_id: number;
  page_id: number;
  title: string | null;
  description: string | null;
  site_geos: number[];
  site_tags: number[];
  site_categories: number[];
  text_ads_categories: number[];
  check_url: CheckUrlResponse;
}

export const getUrlInfo = (url: string) =>
  instance.get<UrlInfoResponse>('/profile/get-site-info', {
    params: {
      url,
    },
  });

interface NavigationAds {
  cams: {
    url: string;
    bid_price: number;
  };
  dating: {
    url: string;
    bid_price: number;
  };
}

export const fetchNavigationAds = (token: string) =>
  instance.post<NavigationAds>('/api/bottom-menu', {
    t: token,
  });
